import {
    fadeIn,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', function() {
    const hotspotSections = document.querySelectorAll('.hotspot-section');
    let isMobile = window.matchMedia('(max-width: 767px)').matches;

    hotspotSections.forEach(section => {
        const hsWrap = section.querySelector('.hs-wrap');
        const popup = section.querySelector('.hs-popup');
        const popupItems = section.querySelectorAll('.hs-popup-item[data-pin-id]');

        if (!hsWrap) {
            return;
        }

        /* ------------------------------------
         * Clone function (desktop only)
         * ------------------------------------ */
        const clonePopupItems = () => {
            popupItems.forEach(item => {
                const pinId = item.getAttribute('data-pin-id');
                const dragEl = document.getElementById(pinId);

                if (dragEl && !dragEl.querySelector('.tooltip-wrap')) {
                    const clone = item.cloneNode(true);
                    clone.classList.add('tooltip-wrap');
                    clone.classList.remove('hs-popup-item');

                    dragEl.appendChild(clone);
                }
            });
        };

        /* ------------------------------------
         * Remove cloned tooltips
         * ------------------------------------ */
        const removeClones = () => {
            section.querySelectorAll('.tooltip-wrap').forEach(el => el.remove());
        };

        /* ------------------------------------
         * Initial load
         * ------------------------------------ */
        if (!isMobile) {
            clonePopupItems();
        }

        /* ------------------------------------
         * Click handler
         * ------------------------------------ */
        hsWrap.addEventListener('click', function(e) {
            e.stopPropagation();

            const dragEl = e.target.closest('.drag_element');
            if (!dragEl) {
                return;
            }
            const pinId = dragEl.id;

            /* ---------- DESKTOP ---------- */
            const allPins = section.querySelectorAll('.drag_element');
            const isAlreadyActive = dragEl.classList.contains('is-active');

            // reset all
            allPins.forEach(el => el.classList.remove('is-active'));

            // toggle current
            if (!isAlreadyActive) {
                dragEl.classList.add('is-active');
            }

            /* ---------- MOBILE ---------- */
            if (isMobile && popup && pinId) {
                popup.classList.add('is-open');
                const activeItem = popup.querySelector('.hs-popup-item[data-pin-id="' + pinId + '"]');

                if (activeItem) {
                    popup.querySelectorAll('.hs-popup-item').forEach(item => {
                        item.classList.remove('is-active');
                        item.style.display = 'none';
                    });

                    activeItem.classList.add('is-active');

                    if (typeof fadeIn === 'function') {
                        fadeIn(activeItem);
                    } else {
                        activeItem.style.display = 'block';
                    }
                }
            }
        });

        /* ------------------------------------
         * Close popup (mobile)
         * ------------------------------------ */
        const closeBtn = section.querySelector('.hs-popup-close');
        if (closeBtn && popup) {
            closeBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                popup.classList.remove('is-open');
                section.querySelector('.is-active').classList.remove('is-active');
            });
        }

        /* ------------------------------------
         * Resize handler
         * ------------------------------------ */
        window.addEventListener('resize', () => {
            const nowMobile = window.matchMedia('(max-width: 767px)').matches;

            if (nowMobile !== isMobile) {
                isMobile = nowMobile;

                // Reset states
                section.querySelectorAll('.drag_element').forEach(el => {
                    el.classList.remove('is-active');
                });

                if (popup) {
                    popup.classList.remove('is-open');
                    popup.querySelectorAll('.hs-popup-item').forEach(item => {
                        item.classList.remove('is-active');
                        item.style.display = '';
                    });
                }

                // Switch behavior
                if (isMobile) {
                    removeClones();
                } else {
                    clonePopupItems();
                }
            }
        });

        document.addEventListener('click', function(event) {
            event.stopPropagation();
            document.querySelectorAll('.drag_element.is-active').forEach(el => {
                el.classList.remove('is-active');
            });
        });
    });
});